import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import clsx from 'clsx';
import styles from './styles.module.scss';
import labelStyles from '@/components/FormElements/Label/styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var TrashIcon = function TrashIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7 8V18C7 19.1046 7.89543 20 9 20H15C16.1046 20 17 19.1046 17 18V8H19V18C19 20.2091 17.2091 22 15 22H9C6.79086 22 5 20.2091 5 18V8H7Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10 11C9.44772 11 9 11.4477 9 12V16C9 16.5523 9.44772 17 10 17C10.5523 17 11 16.5523 11 16V12C11 11.4477 10.5523 11 10 11Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M14 11C13.4477 11 13 11.4477 13 12V16C13 16.5523 13.4477 17 14 17C14.5523 17 15 16.5523 15 16V12C15 11.4477 14.5523 11 14 11Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 6V5C8 3.34315 9.34315 2 11 2H13C14.6569 2 16 3.34315 16 5V6H19C19.5523 6 20 6.44772 20 7C20 7.55228 19.5523 8 19 8H5C4.44772 8 4 7.55228 4 7C4 6.44772 4.44772 6 5 6H8ZM10 5C10 4.44772 10.4477 4 11 4H13C13.5523 4 14 4.44772 14 5V6H10V5Z",
      fill: "#12131A"
    })]
  }));
};

TrashIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var WarningIcon = function WarningIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.7824 14.1068L10.7896 4.10358C10.053 2.62782 7.9472 2.6278 7.21059 4.10357L2.21763 14.1068C1.55392 15.4365 2.52095 17 4.0071 17H13.9929C15.479 17 16.4461 15.4366 15.7824 14.1068ZM12.579 3.21041C11.1059 0.258875 6.89432 0.258861 5.42112 3.21038L0.428157 13.2136C-0.89926 15.8731 1.03478 19 4.0071 19H13.9929C16.9652 19 18.8992 15.8731 17.5719 13.2137L12.579 3.21041Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10 6C10 5.44772 9.55228 5 9 5C8.44772 5 8 5.44772 8 6V10C8 10.5523 8.44772 11 9 11C9.55228 11 10 10.5523 10 10V6Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9 13C8.44772 13 8 13.4477 8 14C8 14.5523 8.44772 15 9 15C9.55228 15 10 14.5523 10 14C10 13.4477 9.55228 13 9 13Z",
      fill: "#12131A"
    })]
  }));
};

WarningIcon.defaultProps = {
  width: "18",
  height: "19",
  viewBox: "0 0 18 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const OptionsList = _ref => {
  let {
    className = '',
    children
  } = _ref;
  return /*#__PURE__*/_jsx("ul", {
    className: clsx(styles.list, className),
    children: children
  });
};

export default OptionsList;
export const Item = _ref2 => {
  let {
    className = '',
    children
  } = _ref2;
  return /*#__PURE__*/_jsx("li", {
    className: clsx(styles.item, className),
    children: children
  });
};
export const Divider = _ref3 => {
  let {
    className = ''
  } = _ref3;
  return /*#__PURE__*/_jsx("li", {
    className: clsx(styles.divider, className)
  });
};
export const Header = _ref4 => {
  let {
    className = '',
    children,
    headings,
    hasRightIcon = false,
    hasLeftIcon = false
  } = _ref4;
  return /*#__PURE__*/_jsxs("header", {
    className: clsx(styles.header, className),
    children: [hasLeftIcon && /*#__PURE__*/_jsx("span", {
      className: styles.iconButton
    }), headings.map((heading, index) => /*#__PURE__*/_jsx("h6", {
      className: clsx(labelStyles.heading, styles.heading),
      children: heading
    }, `options-list-header-${index}`)), hasRightIcon && /*#__PURE__*/_jsx("span", {
      className: styles.iconButton
    }), children]
  });
};
export const IconButton = _ref5 => {
  let {
    className = '',
    children,
    type = 'trash',
    size = '',
    onClick = () => null
  } = _ref5;
  return /*#__PURE__*/_jsxs("button", {
    className: clsx(styles.iconButton, styles[`iconButton--${type}`], size ? styles[`iconButton--${size}`] : '', className),
    type: "button",
    onClick: onClick,
    children: [type === 'trash' && /*#__PURE__*/_jsx(TrashIcon, {}), type === 'warning' && /*#__PURE__*/_jsx(WarningIcon, {}), children]
  });
};